import {GET, POST} from "@/services/gateway";

const listUsers = ({pagination, search, filter}) => {
  return POST('google/user/list', {pagination, search, filter});
}

const getUserDetails = (id) => {
  return GET('google/drive/user', {id})
}

const listSnapshots = ({userId, date, dateTo}) => {
  return POST('google/drive/snapshot/list', {userId, date, dateTo})
}

const createBackup = (userId) => {
  return GET('google/drive/backup', {userId})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, snapshotId, selectedIds, code, extension, storageDestinationId, dataType, storageDestinationType}) => {
  return POST('google/drive/export', {snapshotDateTime, sourceIds, searchTerm, snapshotId, selectedIds, extension, storageDestinationId, dataType, storageDestinationType}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, RestoreType, code}) => {
  return POST('google/drive/restore', {snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, RestoreType}, {code: code ? code : null});
}

export {
  listUsers,
  getUserDetails,
  listSnapshots,
  createBackup,
  exportSnapshot,
  restoreSnapshot
}
